// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reset */
body {
    margin: 0;
    padding: 0;
    font-family: sans-serif;
    background-color: #1e1e1e;
  }
  
  .ide-page-shell {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background-color: #1e1e1e;
    position: relative;
  }

  .trace-toggle-anchor {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 150;
  }

  .trace-toggle-btn {
    background-color: #0e639c;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    white-space: nowrap;
    box-shadow: 0 6px 16px rgba(0,0,0,0.25);
  }
  .trace-toggle-btn:hover {
    background-color: #1177bb;
  }

  /* top‐level split: IDE on left, steps on right */
  .ide-page-layout {
    display: flex;
    flex: 1 1;
    width: 100%;
    background-color: #1e1e1e;
  }
  
  /* LEFT HALF: IDE container */
  .ide-pane {
    flex: 1 1;               /* half the screen initially */
    position: relative;    /* for absolutely positioned children */
    min-width: 0;          /* prevent overflow */
    height: 100%;
  }
  

  
  /* draggable vertical divider */
  .vertical-resizer {
    width: 5px;               /* bar thickness */
    cursor: ew-resize;        /* east‐west resize cursor */
    background-color: #3c3c3c;
    flex-shrink: 0;           /* never collapse */
    transition: background-color 0.2s;
  }
  .vertical-resizer:hover {
    background-color: #007acc;
  }
  
  /* RIGHT HALF: steps */
.steps-pane {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    background-color: #f4f4f4;
    color: #333;
    padding: 1.5rem;
    border-left: 2px solid #ddd;
    box-sizing: border-box;
    overflow: hidden;
  }

  .steps-pane-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .steps-pane-content {
    flex: 1 1;
    overflow-y: auto;
    padding-right: 0.25rem;
  }

  .no-steps-message {
    color: #666;
  }

  .steps-pane-footer {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
  }

  .steps-submit-btn {
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 0.6rem 1.4rem;
    font-size: 0.95rem;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  .steps-submit-btn:hover {
    background-color: #1f8b36;
  }
  
  .steps-pane h2 {
    margin-top: 0;
    color: #000;
    border-bottom: 2px solid #ccc;
    padding-bottom: 0.5rem;
  }
  
  .step-display-container {
    margin-bottom: 1.5rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }
  
  .step-description-display {
    padding: 1rem;
    border-bottom: 1px solid #eee;
  }
  
  .step-simulation-display pre {
    background-color: #e9ecef;
    color: #000;
    padding: 1rem;
    margin: 0;
    border-radius: 0 0 8px 8px;
    font-family: "SF Mono", "Consolas", "Courier New", monospace;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  
  /* INSIDE IDE pane: vertical layout for editor + console */
  .ide-layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }
  
  /* CodeMirror editor area */
  .editor-pane {
    flex: 1 1;
    min-height: 0;
    overflow: hidden;
  }
  .editor-pane .cm-editor {
    height: 100%;
  }
  
  /* horizontal resizer for console height */
  .resizer {
    background-color: #3c3c3c;
    height: 5px;
    cursor: ns-resize;
    flex-shrink: 0;
    transition: background-color 0.2s;
  }
  .resizer:hover {
    background-color: #007acc;
  }
  
  /* console pane */
  .console-pane {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    background-color: #252526;
  }
  .console-output {
    flex-grow: 1;
    background-color: #1e1e1e;
    color: #d4d4d4;
    padding: 1rem;
    margin: 0;
    font-family: 'SF Mono', 'Consolas', 'Courier New', monospace;
    font-size: 0.9rem;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-y: auto;
  }
  .console-line.log {
    color: #d4d4d4;
    margin-bottom: 4px;
  }
  .console-line.error {
    color: #f48771;
    margin-bottom: 4px;
  }
  
  /* floating controls inside the IDE pane */
  .ide-floating-controls {
    position: absolute;
    bottom: 1.25rem;
    right: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-end;
    z-index: 100;
  }

  .run-button {
    background-color: #0e639c;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 0.6rem 1.4rem;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(0,0,0,0.25);
  }

  .run-button:disabled {
    background-color: #555;
    cursor: not-allowed;
    box-shadow: none;
  }

  .ide-inline-submit-btn {
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 0.6rem 1.4rem;
    font-size: 0.95rem;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(0,0,0,0.25);
  }

  .ide-inline-submit-btn:hover,
  .run-button:not(:disabled):hover {
    filter: brightness(1.05);
  }

  /* notification banner in IDE pane */
  .notification-banner {
    position: absolute;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
    padding: 1rem 1.5rem;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    display: flex;
    align-items: center;
    gap: 1rem;
    z-index: 2000;
    font-size: 1rem;
    border: 1px solid transparent;
  }
  .notification-banner.success {
    background-color: #d4edda;
    border-color: #c3e6cb;
    color: #155724;
  }
  .step-trace-display {
    padding: 0.75rem 1rem;
    border-top: 1px solid #eee;
    background: #fafafa;
  }
  
  .trace-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  
  .trace-table th,
  .trace-table td {
    border: 1px solid #ddd;
    padding: 6px 8px;
    text-align: left;
    vertical-align: top;
    background: #fff;
  }
  
  .trace-table th {
    background: #eef2f7;
    font-weight: 600;
  }
  
  .trace-table td code {
    font-family: "SF Mono","Consolas","Courier New",monospace;
    font-size: 0.95rem;
    white-space: pre-wrap;
    word-break: break-word;
  }
  .step-display-container[style*="marginLeft"] {
  border-left: 3px solid #e0e0e0;
  padding-left: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/IdePage.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,yBAAyB;EAC3B;;EAEA,iDAAiD;EACjD;IACE,aAAa;IACb,SAAO;IACP,WAAW;IACX,yBAAyB;EAC3B;;EAEA,6BAA6B;EAC7B;IACE,SAAO,gBAAgB,8BAA8B;IACrD,kBAAkB,KAAK,uCAAuC;IAC9D,YAAY,WAAW,qBAAqB;IAC5C,YAAY;EACd;;;;EAIA,+BAA+B;EAC/B;IACE,UAAU,gBAAgB,kBAAkB;IAC5C,iBAAiB,SAAS,4BAA4B;IACtD,yBAAyB;IACzB,cAAc,YAAY,mBAAmB;IAC7C,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;AACxB;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,SAAS;IACT,0BAA0B;IAC1B,4DAA4D;IAC5D,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA,0DAA0D;EAC1D;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,2BAA2B;EAC3B;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;;EAEA,0CAA0C;EAC1C;IACE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,iCAAiC;EACnC;EACA;IACE,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,SAAS;IACT,4DAA4D;IAC5D,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA,0CAA0C;EAC1C;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uCAAuC;EACzC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uCAAuC;EACzC;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA,oCAAoC;EACpC;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yDAAyD;IACzD,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;EACA,8BAA8B;EAC9B,kBAAkB;AACpB","sourcesContent":["/* reset */\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: sans-serif;\n    background-color: #1e1e1e;\n  }\n  \n  .ide-page-shell {\n    display: flex;\n    flex-direction: column;\n    width: 100vw;\n    height: 100vh;\n    background-color: #1e1e1e;\n    position: relative;\n  }\n\n  .trace-toggle-anchor {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    z-index: 150;\n  }\n\n  .trace-toggle-btn {\n    background-color: #0e639c;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    padding: 0.5rem 1rem;\n    cursor: pointer;\n    white-space: nowrap;\n    box-shadow: 0 6px 16px rgba(0,0,0,0.25);\n  }\n  .trace-toggle-btn:hover {\n    background-color: #1177bb;\n  }\n\n  /* top‐level split: IDE on left, steps on right */\n  .ide-page-layout {\n    display: flex;\n    flex: 1;\n    width: 100%;\n    background-color: #1e1e1e;\n  }\n  \n  /* LEFT HALF: IDE container */\n  .ide-pane {\n    flex: 1;               /* half the screen initially */\n    position: relative;    /* for absolutely positioned children */\n    min-width: 0;          /* prevent overflow */\n    height: 100%;\n  }\n  \n\n  \n  /* draggable vertical divider */\n  .vertical-resizer {\n    width: 5px;               /* bar thickness */\n    cursor: ew-resize;        /* east‐west resize cursor */\n    background-color: #3c3c3c;\n    flex-shrink: 0;           /* never collapse */\n    transition: background-color 0.2s;\n  }\n  .vertical-resizer:hover {\n    background-color: #007acc;\n  }\n  \n  /* RIGHT HALF: steps */\n.steps-pane {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    background-color: #f4f4f4;\n    color: #333;\n    padding: 1.5rem;\n    border-left: 2px solid #ddd;\n    box-sizing: border-box;\n    overflow: hidden;\n  }\n\n  .steps-pane-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .steps-pane-content {\n    flex: 1;\n    overflow-y: auto;\n    padding-right: 0.25rem;\n  }\n\n  .no-steps-message {\n    color: #666;\n  }\n\n  .steps-pane-footer {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .steps-submit-btn {\n    background-color: #28a745;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: 0.6rem 1.4rem;\n    font-size: 0.95rem;\n    cursor: pointer;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n  }\n  .steps-submit-btn:hover {\n    background-color: #1f8b36;\n  }\n  \n  .steps-pane h2 {\n    margin-top: 0;\n    color: #000;\n    border-bottom: 2px solid #ccc;\n    padding-bottom: 0.5rem;\n  }\n  \n  .step-display-container {\n    margin-bottom: 1.5rem;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background-color: #fff;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n  }\n  \n  .step-description-display {\n    padding: 1rem;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .step-simulation-display pre {\n    background-color: #e9ecef;\n    color: #000;\n    padding: 1rem;\n    margin: 0;\n    border-radius: 0 0 8px 8px;\n    font-family: \"SF Mono\", \"Consolas\", \"Courier New\", monospace;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n  \n  /* INSIDE IDE pane: vertical layout for editor + console */\n  .ide-layout {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    position: relative;\n  }\n  \n  /* CodeMirror editor area */\n  .editor-pane {\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n  }\n  .editor-pane .cm-editor {\n    height: 100%;\n  }\n  \n  /* horizontal resizer for console height */\n  .resizer {\n    background-color: #3c3c3c;\n    height: 5px;\n    cursor: ns-resize;\n    flex-shrink: 0;\n    transition: background-color 0.2s;\n  }\n  .resizer:hover {\n    background-color: #007acc;\n  }\n  \n  /* console pane */\n  .console-pane {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    background-color: #252526;\n  }\n  .console-output {\n    flex-grow: 1;\n    background-color: #1e1e1e;\n    color: #d4d4d4;\n    padding: 1rem;\n    margin: 0;\n    font-family: 'SF Mono', 'Consolas', 'Courier New', monospace;\n    font-size: 0.9rem;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    overflow-y: auto;\n  }\n  .console-line.log {\n    color: #d4d4d4;\n    margin-bottom: 4px;\n  }\n  .console-line.error {\n    color: #f48771;\n    margin-bottom: 4px;\n  }\n  \n  /* floating controls inside the IDE pane */\n  .ide-floating-controls {\n    position: absolute;\n    bottom: 1.25rem;\n    right: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-end;\n    z-index: 100;\n  }\n\n  .run-button {\n    background-color: #0e639c;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: 0.6rem 1.4rem;\n    font-size: 0.95rem;\n    font-weight: 600;\n    cursor: pointer;\n    box-shadow: 0 8px 20px rgba(0,0,0,0.25);\n  }\n\n  .run-button:disabled {\n    background-color: #555;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n\n  .ide-inline-submit-btn {\n    background-color: #28a745;\n    color: #fff;\n    border: none;\n    border-radius: 8px;\n    padding: 0.6rem 1.4rem;\n    font-size: 0.95rem;\n    cursor: pointer;\n    box-shadow: 0 8px 20px rgba(0,0,0,0.25);\n  }\n\n  .ide-inline-submit-btn:hover,\n  .run-button:not(:disabled):hover {\n    filter: brightness(1.05);\n  }\n\n  /* notification banner in IDE pane */\n  .notification-banner {\n    position: absolute;\n    bottom: 2rem;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 1rem 1.5rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    z-index: 2000;\n    font-size: 1rem;\n    border: 1px solid transparent;\n  }\n  .notification-banner.success {\n    background-color: #d4edda;\n    border-color: #c3e6cb;\n    color: #155724;\n  }\n  .step-trace-display {\n    padding: 0.75rem 1rem;\n    border-top: 1px solid #eee;\n    background: #fafafa;\n  }\n  \n  .trace-table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed;\n  }\n  \n  .trace-table th,\n  .trace-table td {\n    border: 1px solid #ddd;\n    padding: 6px 8px;\n    text-align: left;\n    vertical-align: top;\n    background: #fff;\n  }\n  \n  .trace-table th {\n    background: #eef2f7;\n    font-weight: 600;\n  }\n  \n  .trace-table td code {\n    font-family: \"SF Mono\",\"Consolas\",\"Courier New\",monospace;\n    font-size: 0.95rem;\n    white-space: pre-wrap;\n    word-break: break-word;\n  }\n  .step-display-container[style*=\"marginLeft\"] {\n  border-left: 3px solid #e0e0e0;\n  padding-left: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
